var _path, _path2, _path3, _path4, _mask, _ellipse, _path5, _mask2, _ellipse2, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFyndricon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5936 22.8866H6.21872C5.66643 22.8866 5.21871 23.3343 5.21871 23.8866V25.1508M14.5936 22.8866V34.2072M14.5936 22.8866L26.0585 15.1338C26.2239 15.022 26.419 14.9622 26.6187 14.9622H26.781M14.5936 34.2072L26.781 42.6977M14.5936 34.2072H7.56244M26.781 14.9622V12C26.781 11.4477 27.2287 11 27.781 11H29.9997C30.552 11 30.9997 11.4477 30.9997 12V45.6599C30.9997 46.2122 30.552 46.6599 29.9997 46.6599H27.781C27.2287 46.6599 26.781 46.2122 26.781 45.6599V42.6977M26.781 14.9622V37.6034V42.6977M5.21871 25.1508H2C1.44772 25.1508 1 25.5985 1 26.1508V30.9431C1 31.4954 1.44772 31.9431 2 31.9431H5.21871M5.21871 25.1508V31.9431M5.21871 31.9431V33.2072C5.21871 33.7595 5.66643 34.2072 6.21871 34.2072H7.56244M7.56244 34.2072V45.6599C7.56244 46.2122 8.01016 46.6599 8.56244 46.6599H10.7812C11.3334 46.6599 11.7812 46.2122 11.7812 45.6599V34.7733",
    stroke: "url(#paint0_linear_6663_26975)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8548 24.0056C36.5025 24.431 36.5618 25.0613 36.9871 25.4136C37.4125 25.7658 38.0429 25.7066 38.3952 25.2812L36.8548 24.0056ZM39.8014 23.5831C40.1536 23.1578 40.0944 22.5274 39.669 22.1751C39.2437 21.8229 38.6133 21.8821 38.261 22.3075L39.8014 23.5831ZM39.029 28.2398C38.4768 28.2398 38.029 28.6875 38.029 29.2398C38.029 29.7921 38.4768 30.2398 39.029 30.2398V28.2398ZM41.0178 30.2398C41.57 30.2398 42.0178 29.7921 42.0178 29.2398C42.0178 28.6875 41.57 28.2398 41.0178 28.2398V30.2398ZM38.8639 34.1903C38.5117 33.7649 37.8813 33.7057 37.4559 34.0579C37.0305 34.4102 36.9713 35.0406 37.3235 35.4659L38.8639 34.1903ZM38.7298 37.164C39.082 37.5894 39.7124 37.6487 40.1378 37.2964C40.5631 36.9441 40.6224 36.3138 40.2702 35.8884L38.7298 37.164ZM33.6144 34.1015L33.1671 33.2072H33.1671L33.6144 34.1015ZM34.9831 32.9972L35.7533 33.6351L35.7533 33.6351L34.9831 32.9972ZM35.8976 27.4456L36.8435 27.1211L35.8976 27.4456ZM33.6144 24.6886L34.0618 23.7942L34.0618 23.7942L33.6144 24.6886ZM38.3952 25.2812L39.8014 23.5831L38.261 22.3075L36.8548 24.0056L38.3952 25.2812ZM39.029 30.2398H41.0178V28.2398H39.029V30.2398ZM37.3235 35.4659L38.7298 37.164L40.2702 35.8884L38.8639 34.1903L37.3235 35.4659ZM32 35.4893C32.7145 35.4893 33.4158 35.319 34.0618 34.9959L33.1671 33.2072C32.7894 33.3961 32.3935 33.4893 32 33.4893V35.4893ZM34.0618 34.9959C34.7068 34.6733 35.2795 34.2072 35.7533 33.6351L34.2129 32.3594C33.9032 32.7334 33.5457 33.0178 33.1671 33.2072L34.0618 34.9959ZM35.7533 33.6351C36.2268 33.0632 36.5948 32.3939 36.8435 31.669L34.9517 31.0201C34.7763 31.5313 34.5228 31.9852 34.2129 32.3594L35.7533 33.6351ZM36.8435 31.669C37.0922 30.944 37.2187 30.1718 37.2187 29.3951H35.2187C35.2187 29.9563 35.127 30.5089 34.9517 31.0201L36.8435 31.669ZM37.2187 29.3951C37.2187 28.6183 37.0922 27.8461 36.8435 27.1211L34.9517 27.77C35.127 28.2812 35.2187 28.8338 35.2187 29.3951H37.2187ZM36.8435 27.1211C36.5948 26.3962 36.2268 25.7269 35.7533 25.155L34.2129 26.4307C34.5228 26.8049 34.7763 27.2588 34.9517 27.77L36.8435 27.1211ZM35.7533 25.155C35.2795 24.5829 34.7068 24.1168 34.0618 23.7942L33.1671 25.5829C33.5457 25.7723 33.9032 26.0567 34.2129 26.4307L35.7533 25.155ZM34.0618 23.7942C33.4158 23.4711 32.7145 23.3008 32 23.3008V25.3008C32.3935 25.3008 32.7894 25.394 33.1671 25.5829L34.0618 23.7942Z",
    fill: "url(#paint1_linear_6663_26975)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42 12V3C42 1.89543 42.8954 1 44 1H57C58.1046 1 59 1.89543 59 3V12C59 13.1046 58.1046 14 57 14H44C42.8954 14 42 13.1046 42 12Z",
    stroke: "url(#paint2_linear_6663_26975)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.25 48.332L47.625 53.6654",
    stroke: "url(#paint3_linear_6663_26975)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-1_6663_26975",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5625,
    cy: 49.2209,
    rx: 0.937492,
    ry: 0.888896
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5625,
    cy: 49.2209,
    rx: 0.937492,
    ry: 0.888896,
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 49.2209C48.5 49.1725 48.5224 49.138 48.5374 49.1238C48.5514 49.1105 48.5625 49.1098 48.5625 49.1098V51.1098C49.5817 51.1098 50.5 50.3136 50.5 49.2209H48.5ZM48.5625 49.1098C48.5625 49.1098 48.5736 49.1105 48.5876 49.1238C48.6026 49.138 48.625 49.1725 48.625 49.2209H46.625C46.625 50.3136 47.5433 51.1098 48.5625 51.1098V49.1098ZM48.625 49.2209C48.625 49.2693 48.6026 49.3039 48.5876 49.318C48.5736 49.3314 48.5625 49.332 48.5625 49.332V47.332C47.5433 47.332 46.625 48.1282 46.625 49.2209H48.625ZM48.5625 49.332C48.5625 49.332 48.5514 49.3314 48.5374 49.318C48.5224 49.3039 48.5 49.2693 48.5 49.2209H50.5C50.5 48.1282 49.5817 47.332 48.5625 47.332V49.332Z",
    fill: "url(#paint4_linear_6663_26975)",
    mask: "url(#path-5-inside-1_6663_26975)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-2_6663_26975",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.3125,
    cy: 52.7795,
    rx: 0.937492,
    ry: 0.888896
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.3125,
    cy: 52.7795,
    rx: 0.937492,
    ry: 0.888896,
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.25 52.7795C52.25 52.7311 52.2724 52.6966 52.2874 52.6824C52.3014 52.6691 52.3125 52.6684 52.3125 52.6684V54.6684C53.3317 54.6684 54.25 53.8722 54.25 52.7795H52.25ZM52.3125 52.6684C52.3125 52.6684 52.3236 52.6691 52.3376 52.6824C52.3526 52.6966 52.375 52.7311 52.375 52.7795H50.375C50.375 53.8722 51.2933 54.6684 52.3125 54.6684V52.6684ZM52.375 52.7795C52.375 52.8279 52.3526 52.8625 52.3376 52.8766C52.3236 52.8899 52.3125 52.8906 52.3125 52.8906V50.8906C51.2933 50.8906 50.375 51.6868 50.375 52.7795H52.375ZM52.3125 52.8906C52.3125 52.8906 52.3014 52.8899 52.2874 52.8766C52.2724 52.8625 52.25 52.8279 52.25 52.7795H54.25C54.25 51.6868 53.3317 50.8906 52.3125 50.8906V52.8906Z",
    fill: "url(#paint5_linear_6663_26975)",
    mask: "url(#path-7-inside-2_6663_26975)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7165 45.2222H53.6772C53.1019 45.2222 52.5484 45.0016 52.131 44.6057C51.2062 43.7289 49.7381 43.7957 48.8968 44.7529L48.7875 44.8773C48.3465 45.3791 47.7108 45.6667 47.0428 45.6667H46.442C45.3375 45.6667 44.4918 46.6494 44.6563 47.7416C44.7529 48.3824 44.4987 49.0258 43.9902 49.4275L43.9283 49.4764C42.9443 50.2539 42.9443 51.7462 43.9283 52.5237L43.9902 52.5726C44.4987 52.9744 44.7529 53.6178 44.6563 54.2586C44.4918 55.3507 45.3375 56.3334 46.442 56.3334H46.7867C47.3249 56.3334 47.8427 56.5399 48.2333 56.9102L48.7384 57.3892C49.6662 58.2689 51.139 58.2018 51.9831 57.2415L52.0838 57.1269C52.5194 56.6313 53.1741 56.3867 53.8279 56.4752C55.0102 56.6354 56.0624 55.7112 56.0624 54.5181C56.0624 53.9758 56.2853 53.4554 56.6788 53.0823L57.0424 52.7375C58.0091 51.821 57.9387 50.2604 56.8935 49.4345C56.3686 49.0198 56.0624 48.3876 56.0624 47.7186V47.5681C56.0624 46.2725 55.0121 45.2222 53.7165 45.2222Z",
    stroke: "url(#paint6_linear_6663_26975)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6663_26975",
    x1: 2.13244,
    y1: 10.0399,
    x2: 35.4716,
    y2: 41.9675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6663_26975",
    x1: 32.3404,
    y1: 22.5797,
    x2: 44.5673,
    y2: 31.8215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6663_26975",
    x1: 42.6417,
    y1: 0.649999,
    x2: 53.904,
    y2: 17.415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6663_26975",
    x1: 47.8373,
    y1: 48.1884,
    x2: 52.746,
    y2: 54.0817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6663_26975",
    x1: 47.6958,
    y1: 48.2842,
    x2: 49.332,
    y2: 50.2486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6663_26975",
    x1: 51.4458,
    y1: 51.8428,
    x2: 53.082,
    y2: 53.8072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6663_26975",
    x1: 42.637,
    y1: 42.5692,
    x2: 57.3631,
    y2: 60.2491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFyndricon2);
export default __webpack_public_path__ + "static/media/fyndricon2.49da3310cb6f64841529a8f542746633.svg";
export { ForwardRef as ReactComponent };